let $ = require('jquery');
import enquire from 'enquire.js';

function toc() {

  var allTitles = $('.toc-js .js-accordion-title');
  var allPanels = $('.toc-js .js-accordion-panel');
  enquire.register('screen', {

    match: function() {
      allPanels.hide();
      allTitles.on('click.accordion-title', function() {
        var content = $(this).next('.js-accordion-panel');
        if (content.is(':hidden')) {
          $(this).addClass('is-open');
          content.slideDown();
        } else {
          var that = this;
          content.slideUp(null, function() {
            $(that).removeClass('is-open');
          });
        }
        return false;
      });

    },

    unmatch: function() {
      allTitles.off('click.accordion-title').removeClass('is-open');
      allPanels.show();
    }

  });
}

export default toc;
